import React from 'react';
import { voices } from '../../data/voices';
import { SectionHeading } from '../ui/SectionHeading';
import { useBrand } from '../../contexts/BrandContext';
interface VoicesProps {
  limit?: number;
}
export function Voices({
  limit
}: VoicesProps) {
  const {
    brand
  } = useBrand();
  const shown = limit ? voices.slice(0, limit) : voices;
  const [lead, ...rest] = shown;
  return <section className="bg-cream-light" aria-labelledby="voices-heading" data-id="element-251" data-mp="3akgbhgpiuvvr">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-252" data-mp="3aibvw1i9g8fn">
        <SectionHeading eyebrow="In their words" title="Not about weight lost. About being believed." intro="Every woman here arrived having already been told it was nothing." data-id="element-253" data-mp="3fbyba1ft6qf5" />

        <div className="mt-14 grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-254" data-mp="36j324wn80ak3">
          <figure className="flex flex-col" data-id="element-255" data-mp="2rm3zzob519x0">
            <blockquote className="font-serif text-[1.75rem] leading-[1.25] text-ink md:text-[2.5rem]" data-id="element-256" data-mp="2wknkrldzwfns">
              “{lead.quote}”
            </blockquote>
            <figcaption className="rule mt-8 pt-5 text-sm text-ink-soft" data-id="element-257" data-mp="2ev5bczl42na7">
              <span className="text-ink" data-id="element-258" data-mp="29wk9ywu4hxk6">{lead.name}</span>, {lead.age} · {lead.stage}
            </figcaption>
            <img src={brand.images.together} alt="Two women sitting close together on a sofa in lamplight, mid-conversation." className="mt-10 h-64 w-full rounded-brand object-cover md:h-80" loading="lazy" data-id="element-259" data-mp="2nw3i3pmxp8wh" />
          </figure>

          <ul className="flex flex-col" data-id="element-260" data-mp="1r870qijoa9k7">
            {rest.map(voice => <li key={voice.name} className="rule py-7 first:border-t-0 first:pt-0" data-id="element-261" data-mp="24z26hlyvkajk">
                <blockquote className="leading-relaxed text-ink" data-id="element-262" data-mp="2082copl1y8la">“{voice.quote}”</blockquote>
                <p className="mt-4 text-sm text-ink-soft" data-id="element-263" data-mp="1chzowlo67osh">
                  <span className="text-ink" data-id="element-264" data-mp="1cgeucw1uw5um">{voice.name}</span>, {voice.age} · {voice.stage}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}